import { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const IconVideoCamera: FC<IProps> = ({
  width = 24,
  height = 24,
  color = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19762_30012)">
        <path
          d="M22.7143 6.38973L19.2857 8.36384V4.29241C19.2857 3.34688 18.517 2.57812 17.5714 2.57812H1.71429C0.76875 2.57812 0 3.34688 0 4.29241V19.721C0 20.6665 0.76875 21.4353 1.71429 21.4353H17.5714C18.517 21.4353 19.2857 20.6665 19.2857 19.721V15.6496L22.7143 17.6237C23.2848 17.9531 24 17.5406 24 16.8844V7.1317C24 6.47277 23.2848 6.06027 22.7143 6.38973ZM17.3571 19.5067H1.92857V4.5067H17.3571V19.5067ZM22.0714 15.0335L19.2857 13.4317V10.5844L22.0714 8.97991V15.0335ZM3.85714 7.93527H6.85714C6.975 7.93527 7.07143 7.83884 7.07143 7.72098V6.43527C7.07143 6.31741 6.975 6.22098 6.85714 6.22098H3.85714C3.73929 6.22098 3.64286 6.31741 3.64286 6.43527V7.72098C3.64286 7.83884 3.73929 7.93527 3.85714 7.93527Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19762_30012">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconVideoCamera;
